import { FC } from 'react'
import { SvgProps } from './svgProps'

const PhoneIcon: FC<SvgProps> = ({ width, height, color }) => (
  <svg
    width={width || '30'}
    height={height || '30'}
    viewBox="0 0 666 833"
    fill={color || '#000'}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M444.708 27.5024H225.348C197.802 27.5024 175.398 49.9201 175.398 77.4824V599.953C175.398 627.516 197.802 649.933 225.348 649.933H444.708C472.254 649.933 494.658 627.516 494.658 599.953V77.4824C494.658 49.9268 472.254 27.5024 444.708 27.5024ZM487.998 599.953C487.998 623.837 468.578 643.269 444.708 643.269H225.348C201.478 643.269 182.058 623.837 182.058 599.953V77.4824C182.058 53.5987 201.478 34.1664 225.348 34.1664H444.708C468.578 34.1664 487.998 53.5987 487.998 77.4824V599.953Z"
      fill="black"
    />
    <path
      d="M189.89 569.812H480.173V88.8977H189.89V569.812ZM196.55 95.5617H473.513V563.148H196.55V95.5617Z"
      fill="black"
    />
    <path
      d="M335.031 575.323C319.114 575.323 306.167 588.278 306.167 604.198C306.167 620.119 319.114 633.073 335.031 633.073C350.942 633.073 363.889 620.119 363.889 604.198C363.889 588.278 350.942 575.323 335.031 575.323ZM335.031 626.416C322.79 626.416 312.827 616.453 312.827 604.205C312.827 591.957 322.79 581.994 335.031 581.994C347.272 581.994 357.229 591.963 357.229 604.205C357.229 616.447 347.272 626.416 335.031 626.416Z"
      fill="black"
    />
    <path
      d="M335.031 52.2591C338.739 52.2591 341.745 49.2516 341.745 45.5418C341.745 41.8319 338.739 38.8245 335.031 38.8245C331.324 38.8245 328.318 41.8319 328.318 45.5418C328.318 49.2516 331.324 52.2591 335.031 52.2591Z"
      fill="black"
    />
    <path
      d="M289.104 67.6729L292.867 67.2397V63.9077L292.434 60.1426H289.104L285.334 60.5757V63.9077L285.774 67.6729H289.104Z"
      fill="black"
    />
    <path
      d="M307.139 67.8795H362.923C365.334 67.8795 367.226 66.1336 367.226 63.9078C367.226 61.682 365.334 59.936 362.923 59.936H307.139C304.728 59.936 302.837 61.682 302.837 63.9078C302.837 66.1336 304.728 67.8795 307.139 67.8795Z"
      fill="black"
    />
  </svg>
)

export default PhoneIcon
